/*
 * @描叙: websocket
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-03-09 14:33:14 
*/

import Socket from '@/utils/socket'
import config from '@/config'

const wsConfig = {
    //网址（端口是我下面的服务器的端口）
   url: config.WEBSOCKET,
  //心跳时间（单位:ms）
  //heartBeat:5000,
  //发送心跳信息（支持json传入）(这个一般内容不重要，除非后端变态)
  //heartMsg:'hello',
  //开起重连        重新连接没有发送ID
  //reconnect:true,
  //重连间隔时间（单位:ms）
  //reconnectTime:5000,
  //重连次数
//   'reconnectTimes': 5
}

const socket = {
    state: {
        /*WS*/
        WS: null,
        /*msg返回信息存放*/
        WS_MSG: null,
        // 通知消息
        ws_notice: null,
        // 实时读数
        ws_terminalReading: null,
    },
    mutations: {
        CONNET: (state) => {
            state.WS = new Socket(wsConfig);
        },
        SET_MSG: (state, data) => {
            state.WS_MSG = data
        },
        SET_TR: (state, data) => {
            state.ws_terminalReading = data
        },
        SET_NOTICE: (state, data) => {
            state.ws_notice = data
        },
    },
    actions: {
        socketLogin({ commit, state }) {
            commit('CONNET');
            // 监听msg
            state.WS.onmessage(res => {
                if (JSON.parse(res) === null){
                    new Promise((resolve) => {
                        resolve();
                    })
                }else{
                    res = JSON.parse(res)
                    if (res.type == 1) {
                        commit('SET_NOTICE', res.data);
                    }
                    if (res.type == 2) {
                        commit('SET_TR', res.data);
                    }
                    commit('SET_MSG', res);
                }
            })
            return new Promise((resolve) => {
                resolve();
            })
        }
    }
}

export default socket